import React, { useEffect } from "react";
import RecursiveMenu from "@/components/Menu/RecursiveMenu";
import { MenuItem } from "@/components/Menu/menu.interface";
import { menuListData } from "@/components/Menu/helpers";
import useScrollDirection from "@/redux/hooks/useScrollDirection";
import styles from "./menu.module.scss";

interface MenuProps {
  data?: MenuItem[];
  isOpen?: boolean;
}

const Menu: React.FC<MenuProps> = ({ data = menuListData, isOpen }) => {
  const scrollDirection = useScrollDirection();

  useEffect(() => {
    const updateMWebOptionScroll = () => {
      if (isOpen) {
        document.body.classList.add("hideScroll");
      } else {
        document.body.classList.remove("hideScroll");
      }
    };

    updateMWebOptionScroll();

    return () => {
      document.body.classList.remove("hideScroll");
    };
  }, [isOpen]);

  return (
    <div
      className={`${styles.root} ${styles.fixed} ${scrollDirection === "down" ? styles.headerHidden : ""} ${isOpen ? styles.open : ""}`}
    >
      <ul className={styles.listRoot}>
        {data.map((item: MenuItem) => {
          return (
            <li key={item?.slug} className={styles.list}>
              <RecursiveMenu item={item} isHeadNav />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Menu;
